var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "location-contacts__contacts" }, [
    _c("label", { staticClass: "location-contacts__contacts--label" }, [
      _vm._v(_vm._s(_vm.title)),
    ]),
    _vm._v(" "),
    _vm.contacts.length
      ? _c(
          "ul",
          { staticClass: "contact-list" },
          _vm._l(_vm.contacts, function (item, index) {
            return _c("li", { key: index, staticClass: "contact" }, [
              _c("div", { staticClass: "contact__name" }, [
                _c("div", { staticClass: "contact-mail-to-name" }, [
                  _c(
                    "a",
                    { attrs: { href: "mailto:" + item.email, target: "_top" } },
                    [_vm._v(_vm._s(item.name))]
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "contact-mail-to-tip" }, [
                  _vm._v(_vm._s(item.email)),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "contact__title" }, [
                _vm._v(_vm._s(item.title)),
              ]),
            ])
          }),
          0
        )
      : _c("div", [_vm._v("--")]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }